/*
Contains all the routes pertaining to Auth Layout
Use the following structure: 
export const {name}Route = {
  ID: "",
  path: "/",
  element: "",
  index: true, (if the path is default for some folder)
}
*/

import pages from "../../constants/pages";

import LogIn from "../../pages/auth/LogIn";
import SignUp from "../../pages/auth/SignUp";
import ResetPassword from "../../pages/reset password components/ResetPassword";
import ResetChangePassword from "../../pages/reset password components/ChangePassword";

const authLayoutRoutes = {
  signInRoute: {
    ID: pages.signIn.ID,
    path: pages.signIn.route,
    element: LogIn,
    role: ["SUPER_ADMIN", "monetization", "promotion"],
  },

  resetEmailRoute: {
    ID: pages.resetEmailPasswordPage.ID,
    path: pages.resetEmailPasswordPage.route,
    element: ResetPassword,
  },

  forgotPasswordRoute: {
    ID: pages.forgotPasswordPage.ID,
    path: pages.forgotPasswordPage.route + ":code",
    element: ResetChangePassword,
  },
};

export default authLayoutRoutes;
